const PENDING_POST_LOGIN_REDIRECT_KEY = 'pending_post_login_redirect_to';
const CLEARED_POST_LOGIN_REDIRECT_KEY = 'cleared_post_login_redirect_to';

const getSessionStorage = (): Storage | null => {
	if (typeof globalThis === 'undefined' || !globalThis.sessionStorage) {
		return null;
	}

	return globalThis.sessionStorage;
};

export const markPendingPostLoginRedirect = (redirectTo: string): void => {
	const sessionStorage = getSessionStorage();
	if (!sessionStorage || !redirectTo) {
		return;
	}

	sessionStorage.setItem(PENDING_POST_LOGIN_REDIRECT_KEY, redirectTo);
};

export const clearPendingPostLoginRedirect = (): void => {
	const sessionStorage = getSessionStorage();
	if (!sessionStorage) {
		return;
	}

	sessionStorage.removeItem(PENDING_POST_LOGIN_REDIRECT_KEY);
};

export const resetClearedPostLoginRedirect = (): void => {
	const sessionStorage = getSessionStorage();
	if (!sessionStorage) {
		return;
	}

	sessionStorage.removeItem(CLEARED_POST_LOGIN_REDIRECT_KEY);
};

export const wasPostLoginRedirectCleared = (redirectTo: string | null): boolean => {
	const sessionStorage = getSessionStorage();
	if (!sessionStorage || !redirectTo) {
		return false;
	}

	return sessionStorage.getItem(CLEARED_POST_LOGIN_REDIRECT_KEY) === redirectTo;
};

export const clearRedirectOnSchedulingRoute = (): void => {
	const sessionStorage = getSessionStorage();
	if (!sessionStorage) {
		return;
	}

	const pendingRedirectTo = sessionStorage.getItem(PENDING_POST_LOGIN_REDIRECT_KEY);
	if (!pendingRedirectTo) {
		return;
	}

	sessionStorage.removeItem(PENDING_POST_LOGIN_REDIRECT_KEY);
	sessionStorage.setItem(CLEARED_POST_LOGIN_REDIRECT_KEY, pendingRedirectTo);
};
